import { CheckCircle2, Cctv, Houses, Landmark, TrainFront, TrendingUp, Users, Waypoints } from 'lucide-react';

/** One icon per kind of alert, the same ones the left menu uses for that area (15 Oct 2026). */
export function alertIcon(type: string, key?: string, severity?: string) {
  if (severity === 'info') return CheckCircle2;
  if (key?.startsWith('train_surge')) return TrainFront;
  switch (type) {
    case 'darshan': return Landmark;      // temple
    case 'safety': return Users;          // crowd
    case 'queue': return Waypoints;       // queue lines
    case 'holding': return Houses;        // holding areas
    case 'camera':
    case 'data': return Cctv;             // cameras / counts
    case 'forecast': return TrendingUp;   // city surge, record day
    default: return Users;
  }
}
